import { config } from "@repo/config";
import {
	AccountDeletionSection,
	DataExportSection,
} from "@saas/settings/components/PrivacySettings";
import { SettingsPageIntro } from "@saas/settings/components/SettingsLayout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_account/settings/privacy")({
	head: () => ({ meta: [{ title: `Privacy and data - ${config.appName}` }] }),
	component: PrivacySettingsPage,
});

function PrivacySettingsPage() {
	return (
		<>
			<SettingsPageIntro title="Privacy and data" />
			<DataExportSection />
			<AccountDeletionSection />
		</>
	);
}
